import React from 'react'
import { Grid, InputLabel, TextField, FormHelperText } from '@mui/material'
import { Controller, useFormContext, get } from 'react-hook-form'

import useStyles from './styles'

const defaultSx = {
  '& .MuiInputBase-input': {
    fontSize: '14px',
  },
  '& .MuiOutlinedInput-root': {
    height: '40px',
  },
}

export function TextInput({ name, defaultValue, label, error = '', rules, ...props }) {
  const styles = useStyles()
  const {
    control,
    formState: { errors },
  } = useFormContext()

  const errorMessage = error || get(errors, name)?.message

  return (
    <Grid className={styles.container}>
      {label ? (
        <InputLabel
          id={name}
          variant="standard"
          disabled={props.disabled ?? false}
          style={{
            color: errorMessage ? '#C90000' : null,
            marginLeft: '-40px',
          }}
          className={styles.label}
        >
          {label}
          {props?.required && <span className={styles.required}>*</span>}
        </InputLabel>
      ) : null}
      <Controller
        control={control}
        name={name}
        rules={rules}
        defaultValue={defaultValue || ''}
        render={field => (
          <TextField
            {...field}
            id={name}
            variant="outlined"
            error={!!errorMessage}
            multiline
            minRows={1}
            maxRows={1}
            fullWidth
            InputProps={{ style: { padding: '8px 10px', alignSelf: 'center' } }}
            inputProps={{
              'data-field-path': name,
            }}
            sx={defaultSx}
            {...props}
          />
        )}
      />
      {errorMessage && (
        <FormHelperText className={styles.errorMessage} error={!!errorMessage}>
          {errorMessage}
        </FormHelperText>
      )}
    </Grid>
  )
}
